import { addEvent } from "../addEvent/addEvent";

export function scrollIt(
  destination,
  duration = 200,
  easing = "linear",
  callback
) {
  const easings = {
    linear(t) {
      return t;
    },
    easeInQuad(t) {
      return t * t;
    },
    easeOutQuad(t) {
      return t * (2 - t);
    },
    easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
    easeInCubic(t) {
      return t * t * t;
    },
    easeOutCubic(t) {
      return --t * t * t + 1;
    },
    easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    },
    easeInQuart(t) {
      return t * t * t * t;
    },
    easeOutQuart(t) {
      return 1 - --t * t * t * t;
    },
    easeInOutQuart(t) {
      return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
    },
    easeInQuint(t) {
      return t * t * t * t * t;
    },
    easeOutQuint(t) {
      return 1 + --t * t * t * t * t;
    },
    easeInOutQuint(t) {
      return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
    },
  };

  let idAnim;

  const start = window.pageYOffset;
  const startTime =
    "now" in window.performance ? performance.now() : new Date().getTime();

  const documentHeight = Math.max(
    document.body.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.clientHeight,
    document.documentElement.scrollHeight,
    document.documentElement.offsetHeight
  );
  const windowHeight =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.getElementsByTagName("body")[0].clientHeight;
  const destinationOffset =
    typeof destination === "number" ? destination : destination.offsetTop;
  const destinationOffsetToScroll = Math.round(
    documentHeight - destinationOffset < windowHeight
      ? documentHeight - windowHeight
      : destinationOffset
  );

  const maxScroll =
    Math.max(
      document.body.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.clientHeight,
      document.documentElement.scrollHeight,
      document.documentElement.offsetHeight
    ) - window.innerHeight;

  if ("requestAnimationFrame" in window === false) {
    window.scroll({
      top: destinationOffsetToScroll,
      left: 0,
      behavior: "smooth",
    });
    if (callback) {
      callback();
    }
    return;
  }

  function isMicrosoftEdgeBrowser(userAgent) {
    if (userAgent.indexOf("chrome") !== -1 && userAgent.indexOf("edg") !== -1) {
      return true;
    }
    return false;
  }

  function scroll() {
    const now =
      "now" in window.performance ? performance.now() : new Date().getTime();
    const time = Math.min(1, (now - startTime) / duration);
    const timeFunction = easings[easing](time);
    const y = Math.ceil(
      timeFunction * (destinationOffsetToScroll - start) + start
    );

    if (destinationOffsetToScroll > maxScroll) {
      destinationOffsetToScroll = maxScroll;
    }

      if (isMicrosoftEdgeBrowser(navigator.userAgent.toLowerCase())) {
        if (callback) {
          callback();
        }
        return false;
        /*
        addEvent(window, "wheel", function (e) {
          e.preventDefault();
          return false;
          const wd = e.deltaY;
          window.scrollTo(0, y - wd);
        });*/
      } else {
        window.scroll(0, y);
      }

    if (y === destinationOffsetToScroll) {
      if (callback) {
        callback();
      }
      return;
    }
    idAnim = requestAnimationFrame(scroll);
  }

  cancelAnimationFrame(idAnim);
  scroll();
}
